// src/utils/plantillasDocumentos.js
// Modelos de datos y estilos para Presupuestos, Notas de Pago y Remisiones de Cobro

export const FUENTES_DISPONIBLES = [
    { id: 'segoe', nombre: 'Segoe UI / Inter (Moderna Ejecutiva)', fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, sans-serif" },
    { id: 'inter', nombre: 'Inter / Roboto (Limpia Digital)', fontFamily: "'Inter', 'Roboto', sans-serif" },
    { id: 'montserrat', nombre: 'Montserrat (Geométrica Corporativa)', fontFamily: "'Montserrat', sans-serif" },
    { id: 'opensans', nombre: 'Open Sans (Alta Legibilidad)', fontFamily: "'Open Sans', sans-serif" },
    { id: 'poppins', nombre: 'Poppins (Contemporánea Amigable)', fontFamily: "'Poppins', sans-serif" },
    { id: 'lato', nombre: 'Lato (Armoniosa y Equilibrada)', fontFamily: "'Lato', sans-serif" },
    { id: 'merriweather', nombre: 'Merriweather (Serif Tradicional)', fontFamily: "'Merriweather', Georgia, serif" },
    { id: 'playfair', nombre: 'Playfair Display (Serif de Prestigio)', fontFamily: "'Playfair Display', Times, serif" },
    { id: 'jetbrains', nombre: 'JetBrains Mono (Técnica / Monospace)', fontFamily: "'JetBrains Mono', 'Courier New', monospace" }
];

export const TEMAS_ZEN = {
    domus: {
        id: 'domus',
        nombre: 'Azul Ejecutivo & Teal (Domus Habita)',
        primario: '#1e3a8a',
        secundario: '#0d9488',
        acento: '#10b981',
        dorado: '#f59e0b',
        fondoHeader: '#f8fafc',
        borde: '#cbd5e1',
        gradienteBarra: 'linear-gradient(90deg, #10b981 0%, #0d9488 40%, #1e3a8a 75%, #f59e0b 100%)',
        tablaCabecera: '#1e3a8a',
        tablaTexto: '#ffffff',
        totalFila: '#0f172a',
        totalMonto: '#38bdf8'
    },
    esmeralda: {
        id: 'esmeralda',
        nombre: 'Esmeralda Corporativo',
        primario: '#065f46',
        secundario: '#10b981',
        acento: '#047857',
        dorado: '#d97706',
        fondoHeader: '#f0fdf4',
        borde: '#a7f3d0',
        gradienteBarra: 'linear-gradient(90deg, #059669 0%, #10b981 50%, #34d399 100%)',
        tablaCabecera: '#065f46',
        tablaTexto: '#ffffff',
        totalFila: '#064e3b',
        totalMonto: '#6ee7b7'
    },
    grafito: {
        id: 'grafito',
        nombre: 'Grafito Minimalista',
        primario: '#0f172a',
        secundario: '#334155',
        acento: '#475569',
        dorado: '#64748b',
        fondoHeader: '#f8fafc',
        borde: '#cbd5e1',
        gradienteBarra: 'linear-gradient(90deg, #0f172a 0%, #334155 50%, #64748b 100%)',
        tablaCabecera: '#0f172a',
        tablaTexto: '#ffffff',
        totalFila: '#0f172a',
        totalMonto: '#f1f5f9'
    },
    ambar: {
        id: 'ambar',
        nombre: 'Ámbar & Oro Industrial',
        primario: '#78350f',
        secundario: '#d97706',
        acento: '#b45309',
        dorado: '#f59e0b',
        fondoHeader: '#fffbeb',
        borde: '#fde68a',
        gradienteBarra: 'linear-gradient(90deg, #b45309 0%, #d97706 50%, #f59e0b 100%)',
        tablaCabecera: '#78350f',
        tablaTexto: '#ffffff',
        totalFila: '#451a03',
        totalMonto: '#fde68a'
    },
    zafiro: {
        id: 'zafiro',
        nombre: 'Zafiro Clásico',
        primario: '#1e40af',
        secundario: '#3b82f6',
        acento: '#2563eb',
        dorado: '#60a5fa',
        fondoHeader: '#eff6ff',
        borde: '#bfdbfe',
        gradienteBarra: 'linear-gradient(90deg, #1e3a8a 0%, #2563eb 50%, #60a5fa 100%)',
        tablaCabecera: '#1e40af',
        tablaTexto: '#ffffff',
        totalFila: '#1e3a8a',
        totalMonto: '#93c5fd'
    }
};

export const TAMANOS_HOJA = {
    letter: { id: 'letter', nombre: 'Carta (Letter 216 × 279 mm)', widthMm: 215.9, heightMm: 279.4, cssClass: 'sheet-letter' },
    legal: { id: 'legal', nombre: 'Oficio (Legal 216 × 356 mm)', widthMm: 215.9, heightMm: 355.6, cssClass: 'sheet-legal' },
    a4: { id: 'a4', nombre: 'A4 (210 × 297 mm)', widthMm: 210, heightMm: 297, cssClass: 'sheet-a4' }
};

export const ESTRUCTURAS_CATEGORIAS = {
    presupuesto: {
        id: 'presupuesto',
        nombreLabel: 'Presupuesto Formal',
        badgeDefault: 'VIGENTE',
        badgeColor: '#059669',
        badgeBg: '#ecfdf5',
        tituloDocDefault: 'PRESUPUESTO FORMAL',
        seccionReceptorTitulo: 'Datos del Cliente / Proyecto',
        seccionReceptorDesc: 'Razón social del condominio o cliente, representante de obra y datos de contacto.',
        seccionCondicionesTitulo: 'Condiciones Comerciales y de Servicio',
        seccionCondicionesDesc: 'Anticipo, esquema de pagos, plazo de instalación y términos de garantía.',
        seccionPartidasTitulo: 'Desglose de Partidas, Materiales y Servicios',
        seccionPartidasDesc: 'Conceptos presupuestados, suministros, equipamiento y mano de obra requerida.',
        seccionTotalesTitulo: 'Resumen Financiero e Inversión Total',
        seccionBancosTitulo: 'Datos Bancarios para Anticipo o Liquidación',
        seccionNotaClaveTitulo: 'Condiciones de Contratación y Alcance Técnico',
        seccionFirmasTitulo: 'Formalización y Aceptación de Propuesta',
        rolEmisorSugerido: 'Prestador del Servicio / Domus Habita Soluciones Integrales',
        leyendaEmisorSugerida: '«Cotización formal garantizada sujeta a vigencia»',
        rolReceptorSugerido: 'Aceptación y Visto Bueno del Condominio',
        leyendaReceptorSugerida: '«Aceptación de propuesta y autorización de inicio de trabajos»',
        campoFechaLabel: 'Vigencia de Precios',
        campoFechaPlaceholder: 'Ej. 15 días naturales (al 30/10/2026)',
        campoFechaKey: 'fechaVigencia'
    },
    remision: {
        id: 'remision',
        nombreLabel: 'Remisión de Cobro',
        badgeDefault: 'PENDIENTE DE PAGO',
        badgeColor: '#d97706',
        badgeBg: '#fffbeb',
        tituloDocDefault: 'REMISIÓN DE COBRO',
        seccionReceptorTitulo: 'Datos del Cliente / Deudor del Servicio',
        seccionReceptorDesc: 'Comunidad residencial, persona encargada de liquidación y datos de facturación.',
        seccionCondicionesTitulo: 'Condiciones de Cobro y Recepción',
        seccionCondicionesDesc: 'Periodo de servicio devengado, fecha límite de pago y políticas de cobranza.',
        seccionPartidasTitulo: 'Desglose de Servicios Prestados y Concluidos',
        seccionPartidasDesc: 'Alcance operativo concluido, cuotas devengadas o suministros entregados a cobro.',
        seccionTotalesTitulo: 'Resumen de Liquidación y Saldo a Pagar',
        seccionBancosTitulo: 'Datos Bancarios para Liquidación Inmediata',
        seccionNotaClaveTitulo: 'Condiciones de Finiquito y Política de Cobro',
        seccionFirmasTitulo: 'Validez y Acuse de Remisión de Cobro',
        rolEmisorSugerido: 'Representante / Domus Habita Soluciones Integrales',
        leyendaEmisorSugerida: '«Emisión formal de Remisión de Cobro por servicios concluidos»',
        rolReceptorSugerido: 'Recepción y Compromiso de Liquidación',
        leyendaReceptorSugerida: '«Acuse de recibo y compromiso de liquidación programada»',
        campoFechaLabel: 'Fecha Límite de Pago / Vencimiento',
        campoFechaPlaceholder: 'Ej. 5 días hábiles a partir de su emisión',
        campoFechaKey: 'fechaVencimiento'
    },
    pago: {
        id: 'pago',
        nombreLabel: 'Nota de Pago',
        badgeDefault: '✓ PAGADO EN EFECTIVO',
        badgeColor: '#16a34a',
        badgeBg: '#f0fdf4',
        tituloDocDefault: 'NOTA DE PAGO',
        seccionReceptorTitulo: 'Datos del Cliente / Pagador Acreditado',
        seccionReceptorDesc: 'Titular o condominio que cubrió la liquidación en su totalidad.',
        seccionCondicionesTitulo: 'Condiciones y Modalidad del Pago Recibido',
        seccionCondicionesDesc: 'Método de pago aplicado, referencia bancaria y periodo liquidado ($0.00 adeudo).',
        seccionPartidasTitulo: 'Desglose de Servicios Cubiertos y Liquidados',
        seccionPartidasDesc: 'Servicios, cuotas o pólizas liquidadas al 100% que ampara este comprobante.',
        seccionTotalesTitulo: 'Resumen de Pago y Liquidación Total',
        seccionBancosTitulo: 'Cuenta Receptora del Depósito / Registro Contable',
        seccionNotaClaveTitulo: 'Constancia de No Adeudo y Finiquito Definitivo',
        seccionFirmasTitulo: 'Constancia de Pago y Conformidad Mutua',
        rolEmisorSugerido: 'Receptor del Pago / Domus Habita Soluciones Integrales',
        leyendaEmisorSugerida: '«Recibí el importe acordado a entera satisfacción»',
        rolReceptorSugerido: 'Emisor del Pago / Acreditado',
        leyendaReceptorSugerida: '«Entregué el pago total por los servicios contratados»',
        campoFechaLabel: 'Fecha de Pago / Liquidación',
        campoFechaPlaceholder: 'Ej. 14 de Septiembre de 2026',
        campoFechaKey: 'fechaPago'
    }
};

export const UNIDADES_LIST = [
    'Servicio',
    'Pieza',
    'Metro lineal (m)',
    'Metro cuadrado (m²)',
    'Lote',
    'Lote Completo',
    'Hora',
    'Día',
    'Mes',
    'Anual',
    'Paquete',
    'Único'
];

export const PLANTILLA_PRESUPUESTO_DEFAULT = {
    tipoDocumento: 'presupuesto',
    folio: 'PRE-2026-AVR-036',
    fechaEmision: new Date().toISOString().split('T')[0],
    fechaVigencia: '15 días naturales',
    fechaVencimiento: '',
    moneda: 'MXN - Pesos Mexicanos',
    elaboradoPor: 'Dirección Comercial & Proyectos',
    tituloDocumento: 'PRESUPUESTO FORMAL',
    badgeEstado: 'VIGENTE',
    
    // Configuración visual
    tamanoHoja: 'letter',
    orientacion: 'portrait',
    fuenteId: 'segoe',
    temaId: 'domus',
    
    // Empresa emisora oficial Domus Habita
    emisor: {
        nombre: 'Domus Habita',
        slogan: 'Soluciones Integrales a la Medida · Tomorrow\'s Home, Today',
        direccion: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750',
        contactoInfo: 'domushabitat2025@gmail.com · Tel: 414-226-3804',
        rfc: '',
        detalles: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750 · domushabitat2025@gmail.com · Tel: 414-226-3804',
        logo1Url: '',
        logo2Url: '',
        mostrarLogo1: true,
        mostrarLogo2: false
    },

    // Cliente / Destinatario (Referencia Azua Folio 030)
    cliente: {
        nombre: 'Fraccionamiento Azua, Villa Real',
        contacto: 'C. Ricardo Cruz (Administrador)',
        direccion: 'San Pedro Ahuacatlán, San Juan del Río, Qro.',
        municipioEstado: 'San Juan del Río, Qro.',
        telefono: '414-226-3804',
        email: 'contacto@condominioazua.mx',
        referenciaCondominio: 'Padrón de 110 Domicilios · Límite Operativo 150 Viviendas'
    },

    // Alcance y condiciones de presupuesto formal
    condiciones: {
        formaPago: 'Transferencia electrónica, depósito bancario o efectivo',
        inversionInicial: '60% anticipo al autorizar ($20,896.46) · 40% al concluir ($13,930.98)',
        tiempoEntrega: '4 días hábiles de ejecución teniendo material en sitio',
        plazoInstalacion: '4 días hábiles de ejecución teniendo material en sitio',
        rentaSistemas: '$3,400.00 M.N. / mes (Plataforma + Servidor + Respaldo UPS 2.5h)',
        garantia: '12 meses en hardware y soporte de plataforma continuo',
        terminosPago: 'Transferencia electrónica, depósito bancario o efectivo',
        periodo: 'Póliza Anual con facturación y soporte continuo'
    },

    // Conceptos oficiales de equipamiento y puesta en marcha
    conceptos: [
        {
            id: 'c1',
            cantidad: 1,
            unidad: 'Lote Completo',
            descripcion: 'Suministro de Hardware y Dispositivos de Control de Acceso Perimetral',
            subtitulo: 'Controlador maestro 4 puertas, 2 antenas UHF largo alcance 10-20m IP66, 2 lectores QR/tarjetas, 150 tags RFID parabrisas, 2 pedestales metálicos, 2 fotoceldas y supresor de picos.',
            periodo: 'Adquisición única',
            precioUnitario: 26186.04
        },
        {
            id: 'c2',
            cantidad: 1,
            unidad: 'Servicio',
            descripcion: 'Ingeniería de Instalación, Conexión, Calibración y Puesta en Marcha (4 Días Hábiles)',
            subtitulo: 'Mano de obra calificada: Montaje de pedestales, canalización subterránea, blindaje de cableado, calibración UHF para apertura fluida sin filas y capacitación.',
            periodo: 'Puesta a punto',
            precioUnitario: 8641.39
        }
    ],

    // Desglose financiero
    descuento: 0,
    aplicaIva: false,
    tasaIva: 16,
    retencionIsr: 0,
    
    // Nota clave
    impactoComunitario: 'Esquema de Implementación Física: Anticipo del 60% ($20,896.46 MXN) para pedidos y arranque; saldo del 40% ($13,930.97 MXN) contra entrega y puesta en marcha en 4 días hábiles. Precios netos antes de impuestos (en caso de requerir factura con CFDI se adicionará el 16% de I.V.A.).',
    
    // Cuentas bancarias
    cuentasBancarias: [
        {
            banco: 'BBVA Bancomer',
            titular: 'Andrés Jonnatan Wong Feregrino / Domus Habita',
            clabe: '012 680 01548239012 4',
            cuenta: '1548239012'
        }
    ],

    // Firmas
    firmas: {
        emisorNombre: 'C. Andrés Jonnatan Wong Feregrino',
        emisorCargo: 'Prestador del Servicio / Domus Habita Soluciones Integrales',
        emisorFirmaUrl: '',
        receptorNombre: 'C. Ricardo Cruz',
        receptorCargo: 'Administrador General / Fraccionamiento Azua Villa Real',
        receptorFirmaUrl: ''
    }
};

export const PLANTILLA_NOTA_PAGO_DEFAULT = {
    tipoDocumento: 'pago',
    folio: 'NP-2026-CSF4-001',
    fechaEmision: new Date().toISOString().split('T')[0],
    fechaPago: new Date().toISOString().split('T')[0],
    fechaVigencia: '',
    fechaVencimiento: '',
    moneda: 'MXN - Pesos Mexicanos',
    elaboradoPor: 'Tesorería y Administración',
    tituloDocumento: 'NOTA DE PAGO',
    badgeEstado: '✓ PAGADO EN EFECTIVO',
    metodoPago: 'Efectivo (Liquidado en una sola exhibición)',
    referenciaBancaria: 'LIQ-CSF4-ANUAL-003',

    tamanoHoja: 'letter',
    orientacion: 'portrait',
    fuenteId: 'segoe',
    temaId: 'domus',

    emisor: {
        nombre: 'Domus Habita',
        slogan: 'Soluciones Integrales a la Medida · Tomorrow\'s Home, Today',
        direccion: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750',
        contactoInfo: 'domushabitat2025@gmail.com · Tel: 414-226-3804',
        rfc: '',
        detalles: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750 · domushabitat2025@gmail.com · Tel: 414-226-3804',
        logo1Url: '',
        logo2Url: '',
        mostrarLogo1: true,
        mostrarLogo2: false
    },

    // Cliente (Referencia Oficial Claustros de Santa Fe 4 Folio 003)
    cliente: {
        nombre: 'Condominio Claustros de Santa Fe 4',
        contacto: 'Lic. Verónica García González',
        direccion: 'Santa Cruz Nieto, San Juan del Río, Qro.',
        municipioEstado: 'San Juan del Río, Qro.',
        telefono: '414-226-3804',
        email: 'administracion.csf4@condominios.mx',
        referenciaCondominio: '44 Viviendas · 1 Caseta · 3 Admins · +999 disp. Android/iOS'
    },

    condiciones: {
        periodo: 'Vigencia Anual: 12 meses continuos de servicio',
        terminosPago: 'Efectivo (Liquidado en una sola exhibición a entera satisfacción)',
        tiempoEntrega: 'Operación continua habilitada',
        garantia: '$0.00 Adeudo Pendiente (Saldado al 100% / Sin pasivos)'
    },

    conceptos: [
        {
            id: 'np1',
            cantidad: 1,
            unidad: 'Servicio Anual',
            descripcion: 'Licenciamiento Anual y Puesta en Marcha de Plataforma SaaS «Domus Habita»',
            subtitulo: 'Servicio de software en la nube para administración residencial, vigilancia y control de accesos automatizado QR conforme a Contrato Maestro Folio 3.',
            periodo: '12 Meses Cubiertos',
            precioUnitario: 6346.80
        }
    ],

    descuento: 0,
    aplicaIva: false,
    tasaIva: 16,
    retencionIsr: 0,

    impactoComunitario: 'Vínculo Contractual y Finiquito: Este comprobante ampara el pago total y definitivo acordado en la Cláusula 8 y Tabla 2 del Contrato Maestro Folio 3 celebrado en San Juan del Río, Qro. No genera adeudos acumulados ni saldos insolutos para el periodo anual contratado, extendiéndose el más amplio finiquito que en derecho proceda.',

    cuentasBancarias: [
        {
            banco: 'BBVA Bancomer',
            titular: 'Andrés Jonnatan Wong Feregrino / Domus Habita',
            clabe: '012 680 01548239012 4',
            cuenta: '1548239012'
        }
    ],

    firmas: {
        emisorNombre: 'C. Andrés Jonnatan Wong Feregrino',
        emisorCargo: 'Receptor del Pago / Domus Habita Soluciones Integrales',
        emisorFirmaUrl: '',
        receptorNombre: 'Lic. Verónica García González',
        receptorCargo: 'Administradora y Presidenta / Condominio Claustros de Santa Fe 4',
        receptorFirmaUrl: ''
    }
};

export const PLANTILLA_REMISION_DEFAULT = {
    tipoDocumento: 'remision',
    folio: 'REM-2026-FIO-001',
    fechaEmision: new Date().toISOString().split('T')[0],
    fechaVencimiento: '5 días hábiles a partir de su emisión',
    fechaVigencia: '',
    moneda: 'MXN - Pesos Mexicanos',
    elaboradoPor: 'Área de Cobranza y Cuentas por Cobrar',
    tituloDocumento: 'REMISIÓN DE COBRO',
    badgeEstado: 'PENDIENTE DE PAGO',
    metodoPago: 'Transferencia Electrónica SPEI / Efectivo',

    tamanoHoja: 'letter',
    orientacion: 'portrait',
    fuenteId: 'segoe',
    temaId: 'domus',

    emisor: {
        nombre: 'Domus Habita',
        slogan: 'Soluciones Integrales a la Medida · Tomorrow\'s Home, Today',
        direccion: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750',
        contactoInfo: 'domushabitat2025@gmail.com · Tel: 414-226-3804',
        rfc: '',
        detalles: 'Tablajeros la Calera S/N, Col. Santa Fe, Tequisquiapan, Querétaro, C.P. 76750 · domushabitat2025@gmail.com · Tel: 414-226-3804',
        logo1Url: '',
        logo2Url: '',
        mostrarLogo1: true,
        mostrarLogo2: false
    },

    // Cliente (Referencia Oficial Fiorelo Demo / Remisión de Cobro)
    cliente: {
        nombre: 'Fraccionamiento Fiorelo Qro.',
        contacto: 'Christian Adrián Hernández Ponga',
        direccion: 'Santiago de Querétaro, Qro. (Comunidad Residencial 78 Viviendas)',
        municipioEstado: 'Querétaro, Qro.',
        telefono: '414-226-3804',
        email: 'presidencia.fiorelo@condominios.mx',
        referenciaCondominio: '78 Viviendas · Periodo Demo Concluido (+100 paquetes, +300 visitas)'
    },

    condiciones: {
        periodo: 'Periodo de Evaluación Demo Concluido (1 Mes a Cobro)',
        terminosPago: 'Transferencia bancaria o efectivo antes de la fecha límite',
        tiempoEntrega: 'Servicio devengado y concluido a satisfacción',
        garantia: 'Estatus: Pendiente de Liquidación'
    },

    conceptos: [
        {
            id: 'rem1',
            cantidad: 1,
            unidad: 'Mes Servicio',
            descripcion: 'Licenciamiento y Operación de Plataforma SaaS «Domus Habita» — Periodo de Evaluación',
            subtitulo: 'Ampara la operatividad del sistema durante el periodo demo: Panel web (2 admins), app Android caseta y residentes, web iOS, registro de paquetería y accesos (+300 visitas procesadas). Tarifa preferencial de liquidación demo.',
            periodo: 'Evaluación Demo Concluida',
            precioUnitario: 722.00
        }
    ],

    descuento: 0,
    aplicaIva: false,
    tasaIva: 16,
    retencionIsr: 0,

    impactoComunitario: 'Condiciones de Finiquito Demo: Este estado de cuenta ampara en su totalidad el cierre del periodo de evaluación acordado. Admite pago en efectivo o transferencia electrónica. Una vez cubierto, el fraccionamiento no conserva ningún pasivo pendiente por este concepto. Precios más I.V.A. en caso de requerir factura con CFDI.',

    cuentasBancarias: [
        {
            banco: 'BBVA Bancomer',
            titular: 'Andrés Jonnatan Wong Feregrino / Domus Habita',
            clabe: '012 680 01548239012 4',
            cuenta: '1548239012'
        }
    ],

    firmas: {
        emisorNombre: 'C. Andrés Jonnatan Wong Feregrino',
        emisorCargo: 'Representante / Domus Habita Soluciones Integrales',
        emisorFirmaUrl: '',
        receptorNombre: 'Christian Adrián Hernández Ponga',
        receptorCargo: 'Presidente y Representante / Fraccionamiento Fiorelo Qro.',
        receptorFirmaUrl: ''
    }
};

export const PLANTILLAS_BASE = {
    presupuesto: PLANTILLA_PRESUPUESTO_DEFAULT,
    pago: PLANTILLA_NOTA_PAGO_DEFAULT,
    remision: PLANTILLA_REMISION_DEFAULT
};

